import { TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IModalFooterButton } from 'app/extension/api/modal.model';
import { IDisposable } from 'a365-shell-api';
import { IFormattedError } from 'app/interfaces/IHttpClient';
import { IbizaBannerMode } from '../ibiza-banner/ibiza-banner.model';

export interface IConfirmDialogData {
    title?: string;
    content: string;
    okButtonText?: string;
    okButtonTooltip?: string;
    cancelButtonText?: string;
    progressText?: string;
    ackCheckboxText?: string;
    okCallback?: () => Promise<void> | void;
    cancelCallback?: () => void;
    leftButtons?: IModalFooterButton[];
    hideCancelButton?: boolean;
    disableOkButton?: boolean;
    disableOkButton$?: BehaviorSubject<boolean>;
    hasDoNotShowAgainCheckbox?: boolean;
    onDoNotShowAgainChange?: (checked: boolean) => void;
    useInnerHtml?: boolean;
    hasAckCheckbox?: boolean;
    hasHeaderCloseIcon?: boolean;
    hasBanner?: boolean;
    bannerText?: string;
    bannerType?: IbizaBannerMode;
    bannerHyperlink?: string;
    bannerHyperlinkAction?: () => void;
    bannerInnerHTML?: string;
    hyperLinkMessage?: string;
    showRedirectIcon?: boolean;
    ngContentBelowMessage?: boolean;
    clickHyperLinkCallBack?: () => void;
    renderContent?: (/** @deprecate */ elementId: string, container: HTMLElement, abortSignal: AbortSignal) => IDisposable | undefined | void | PromiseLike<IDisposable | undefined | void>;
    useTemplate?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    template?: TemplateRef<any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    templateData?: any;
    showDialogErrorContent?: boolean;
    errorItems?: IFormattedError[];
    onViewDetailClick?: () => void;
    tridentStartTour?: boolean;
    dialogImageClass?: string;
    /** Optional dialog width (e.g., '500px', '650px') - used for MatDialog config */
    dialogWidth?: string;
    /** Optional panel class for additional styling - used for MatDialog config */
    panelClass?: string;
}

export const confirmDialogSize = {
    extraSmall: '250px',
    small: '372px',
    medium: '500px',
    large: '550px',
    extraLarge: '650px'
};
